import Vue from 'vue';
import VueCurrencyFilter from 'vue-currency-filter';
import { DateTime } from 'luxon';

// Global currency filter
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false,
});

// 30 Vandam St. Unit #2
Vue.filter('formatAddressStreet', function (address) {
  let addressStr = address.street;

  if (address.unit) {
    addressStr += `, ${address.unit}`;
  }

  return addressStr;
});

// 30 Vandam St. Unit #2 New York
Vue.filter('formatAddressCity', function (address) {
  let addressStr = address.street;

  if (address.unit) {
    addressStr += `, ${address.unit}`;
  }

  if (address.city) {
    addressStr += `, ${address.city}`;
  }

  return addressStr;
});

// Capitalize string
Vue.filter('capitalize', function capitalize(value) {
  if (!value) {
    return '';
  }

  const capitalizeVal = value.toString();

  return capitalizeVal.charAt(0).toUpperCase() + capitalizeVal.slice(1);
});

// Format Date - 1/20/21
Vue.filter('formatDateFilter', function formatDateFilter(date) {
  if (!date) {
    return '';
  }

  return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_SHORT);
});

// 1/20/21 12:00 PM
Vue.filter('formatDateTime', function (time) {
  return DateTime.fromSQL(`${time} UTC`)
    .toLocaleString(DateTime.DATETIME_SHORT)
    .replace(',', '');
});

// 1/20/21 12:00 PM
Vue.filter('formatDateTimeNoYear', function (time) {
  return DateTime.fromSQL(`${time} UTC`).toFormat('M/d h:mm a');
});

// 1/20/21 12:00 PM
Vue.filter('millasToSql', function (value) {
  return value.replace('T', ' ').replace('.000000Z', '');
});

// 12:00 PM
Vue.filter('formatTime', function (time) {
  return DateTime.fromISO(time).toLocaleString(DateTime.TIME_SIMPLE);
});

// Turns 'enroute_customer' to 'Enroute Customer'
Vue.filter('statusFormat', function statusFormat(value) {
  if (!value) {
    return '';
  }

  const parts = [];

  value.split('_').forEach((el) => {
    parts.push(el.charAt(0).toUpperCase() + el.slice(1));
  });

  return parts.join(' ');
});

// Fulfillment method format logic 'pick_up' to 'Pick up'
// Combine with capitalize filter.
Vue.filter('fulfillmentTypeFormat', function fulfillmentTypeFormat(type) {
  if (!type) return '';

  return type.toLowerCase() === 'pick_up' ? 'Pick Up' : type;
});

// Format phone number 15555555555 -> (555) 555-5555
Vue.filter('phone', function phoneFilter(phone) {
  if (!phone) return '';

  const phoneAbv = phone.replace(/[^0-9]/g, '');

  return phoneAbv
    .slice(phoneAbv.length - 10)
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});
